export default "__VITE_ASSET__42c3fb13__"